import React, { createContext, useCallback, useContext, useState, lazy, Suspense } from "react";
import { openWhatsAppConsulta } from "./whatsappConfig";

const WhatsAppModal = lazy(() => import("../components/WhatsAppFlotante/WhatsAppModal"));

const WhatsAppConsultaContext = createContext(null);

export function useWhatsAppConsulta() {
  const ctx = useContext(WhatsAppConsultaContext);
  if (!ctx) {
    throw new Error("useWhatsAppConsulta debe usarse dentro de WhatsAppConsultaProvider");
  }
  return ctx;
}

export function WhatsAppConsultaProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const openConsultaForm = useCallback(() => {
    setOpen(true);
  }, []);

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      const { updateFirestoreEntry } = await import("./useFirestoreData");
      await updateFirestoreEntry("consultas", "validaciones", values);
      setOpen(false);
      openWhatsAppConsulta();
    } catch {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <WhatsAppConsultaContext.Provider value={{ openConsultaForm, loading }}>
      {children}
      {open && (
        <Suspense fallback={null}>
          <WhatsAppModal
            open={open}
            onClose={() => setOpen(false)}
            onSubmit={handleModalSubmit}
            loading={loading}
          />
        </Suspense>
      )}
    </WhatsAppConsultaContext.Provider>
  );
}
